import { NgModule } from '@angular/core';
import { PwLocaleService } from '@pw-locale';
import { CAPTCHA_SITE_KEY } from '@shared/core/constants/captcha.constant';
import {
  RECAPTCHA_LANGUAGE,
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';

@NgModule({
  declarations: [],
  imports: [RecaptchaModule, RecaptchaFormsModule],
  exports: [RecaptchaModule, RecaptchaFormsModule],
  providers: [
    { provide: RECAPTCHA_SETTINGS, useValue: { siteKey: CAPTCHA_SITE_KEY } as RecaptchaSettings },
    {
      provide: RECAPTCHA_LANGUAGE,
      useFactory: (locale: PwLocaleService) => locale?.currentLanguage,
      deps: [PwLocaleService],
    },
  ],
})
export class CaptchaModule {}
